import { Action, Dispatch } from 'redux';
import { get, set } from 'utils/idb-keyval';
import { NavigationBlock } from 'models/NavigationBlock';
import { getBrandsMenu } from 'services/ApiAppShellService';
import { addHours, isFuture } from 'date-fns';

const prefix = 'header/';
export const HEADER_MAINMENU_OPEN = 'HEADER_MAINMENU_OPEN';
export const HEADER_MAINMENU_CLOSE = 'HEADER_MAINMENU_CLOSE';
export const HEADER_MAINMENU_TOGGLE = 'HEADER_MAINMENU_TOGGLE';
export const SET_BRANDS_MENU = `${prefix}SET_BRANDS_MENU`;

export type SetBrandsMenuAction = { menu: NavigationBlock } & Action;

export const toggleMainMenu = () => ({
  type: HEADER_MAINMENU_TOGGLE
});

export const openMainMenu = () => ({
  type: HEADER_MAINMENU_OPEN
});

export const closeMainMenu = () => ({
  type: HEADER_MAINMENU_CLOSE
});

const STORAGE_KEY_BRANDS_MENU = 'BRANDS_MENU';
const STORAGE_KEY_BRANDS_MENU_CACHE = 'BRANDS_MENU_CACHE';

/*
 * For private windows in FF and Edge there is no access to indexedDB and idb-keyval throws an error
 * We try and catch that here to simply fetch the menu every time instead.
 */
const handleDbAccessError = (e: Error): Promise<[NavigationBlock, Date]> => {
  if (!(e instanceof ReferenceError || e instanceof DOMException)) {
    throw e;
  }
  return getBrandsMenu().then(menu => [menu, getCacheTime()]);
};
const getCacheTime = () => addHours(Date.now(), 1);
export const loadBrandsMenu = () => (dispatch: Dispatch) => {
  void Promise.all([
    get<NavigationBlock>(STORAGE_KEY_BRANDS_MENU),
    get<number>(STORAGE_KEY_BRANDS_MENU_CACHE)
  ])
    .catch(handleDbAccessError)
    .then(([menu, cache]) =>
      menu !== undefined && isFuture(cache)
        ? Promise.resolve(menu)
        : getBrandsMenu().then(menu => {
            void set(STORAGE_KEY_BRANDS_MENU, menu);
            void set(STORAGE_KEY_BRANDS_MENU_CACHE, getCacheTime());
            return menu;
          })
    )
    .then(menu => dispatch(setBrandsMenu(menu)));
};

const setBrandsMenu = (menu: NavigationBlock): SetBrandsMenuAction => ({
  type: SET_BRANDS_MENU,
  menu
});
